import { useState } from 'react';
import { Dropdown } from '../../../UI/Dropdown/Dropdown';
import { ArticleCard } from '../../../components/ArticleCard/ArticleCard';
import { Loader } from '../../../components/Loader/Loader';
import { PageHeader } from '../../../components/PageHeader/PageHeader';
import { PageLayout } from '../../../components/PageLayout/PageLayout';
import { PagePagination } from '../../../components/PagePagination/PagePagination';
import { useFetchArticles } from '../../../hooks/useFetchArticles';
import { useFetchRubrics } from '../../../hooks/useFetchRubrics';
import { PATH_DASHBOARD } from '../../../routes/RouterConfig';
import { DropdownOption } from '../../../types/types';
import Pagination from '../../StaffPages/SupportList/Pagination';
import styles from './UsefulPage.module.scss';

const ALL_RUBRICS: DropdownOption = { value: '', label: 'Все' };

export const UsefulPage = () => {
    const [page, setPage] = useState<number>(1);
    const [rubric, setRubric] = useState<DropdownOption>(ALL_RUBRICS);
    const { rubrics } = useFetchRubrics();
    const rubricOptions: DropdownOption[] = [
        ALL_RUBRICS,
        ...rubrics.map((item) => ({ value: String(item.id), label: item.title })),
    ];
    const { articles, pageCount, isLoading } = useFetchArticles(
        page,
        12,
        rubric.value,
    );

    return (
        <PageLayout>
            <div className={styles.usefulpage}>
                <PagePagination
                    linkName="Полезное"
                    route={PATH_DASHBOARD.useful}
                />
                <PageHeader title="Полезное" />
                <div className={styles.usefulpage__filter}>
                    <h2 className={styles.usefulpage__filter_title}>Рубрика</h2>
                    <Dropdown
                        options={rubricOptions}
                        currentValue={rubric}
                        setCurrentValue={(option) => {
                            setRubric(option);
                            setPage(1);
                        }}
                    />
                </div>
                {isLoading ? (
                    <div className={styles.usefulpage__loader}>
                        <Loader />
                    </div>
                ) : articles?.length ? (
                    <div className={styles.usefulpage__cards}>
                        {articles.map((article) => (
                            <ArticleCard key={article.id} article={article} />
                        ))}
                    </div>
                ) : (
                    <p className={styles.usefulpage__empty}>
                        Материалов пока нет
                    </p>
                )}
                <Pagination
                    list={{ page_count: pageCount, current_page: page }}
                    handlePagination={setPage}
                    isLoading={isLoading}
                />
            </div>
        </PageLayout>
    );
};
